import React, { useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import Checkbox from '@material-ui/core/Checkbox';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import PersonIcon from '@material-ui/icons/Person';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useParams } from 'react-router';
import { makeStyles } from '@material-ui/styles';
import { useAPI } from '../../utils/api';
import { useHistory } from 'react-router-dom';
import { MODE } from '../../utils/mode';
import { useDialog } from '../../utils/dialog';

const useStyles = makeStyles({
  root: {
    '&:last-of-type td': {
      borderBottom: 'none',
    },
  },
});

const createData = ({
  id,
  main,
  isOwner,
  name,
  company,
  tel,
  department,
  address,
  remark,
}) => {
  return {
    id,
    main,
    isOwner,
    name,
    company,
    tel,
    department,
    address,
    remark,
  };
};

const columns = [
  { id: 'main', label: '主聯絡人', minWidth: 75 },
  {
    id: 'name',
    label: '姓名',
  },
  {
    id: 'company',
    label: '公司',
  },
  {
    id: 'tel',
    label: '電話',
  },
  {
    id: 'department',
    label: '部門',
  },
  {
    id: 'address',
    label: '地址',
  },
  {
    id: 'remark',
    label: '備註',
  },
  {
    id: 'function',
    label: '功能',
    minWidth: 440,
  },
];

const ContactsPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const api = useAPI();
  const dialog = useDialog();

  const { memberID } = useParams();

  const [isUnmounted, setIsUnmounted] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [shouldPageUpdate, setShouldPageUpdated] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchContacts = () => {
    const data = { memberID };

    api
      .getContacts(data)
      .then((contacts) => {
        const rows = [];
        for (const contact of contacts) {
          rows.push(createData(contact));
        }
        setContacts(rows);
      })
      .catch(() => {});
  };

  const setAsMainContact = (contactID) => {
    api
      .setMainContact({ contactID })
      .then((isSuccess) => {
        if (isSuccess) {
          fetchContacts();
        } else {
          dialog.Alert({ message: '發生錯誤' });
        }
      })
      .catch(() => {});
  };

  const deleteContact = (contactID) => {
    api
      .deleteContact({ contactID })
      .then((isSuccess) => {
        if (isSuccess) {
          fetchContacts();
        } else {
          dialog.Alert({ message: '發生錯誤' });
        }
      })
      .catch(() => {});
  };

  const editContact = (id) => {
    history.push(`/contact/${MODE.EDIT}/${id}`);
  };
  const viewMore = (id) => {
    history.push(`/contact/${MODE.VIEW}/${id}`);
  };

  const addContact = () => {
    history.push(`/contact/${MODE.NEW}/${memberID}`);
  };

  useEffect(() => {
    if (isUnmounted) return;

    if (!memberID || memberID === 'undefined' || memberID === 'null') {
      history.replace('/');
    }

    fetchContacts();

    return () => {
      setIsUnmounted(true);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!contacts) return;

    setShouldPageUpdated(true);
  }, [contacts]);

  useEffect(() => {
    setShouldPageUpdated(false);
  }, [shouldPageUpdate]);

  return (
    <>
      <Grid container spacing={3} sx={{ width: '360px', marginBottom: 2 }}>
        <Grid item xs={12} sm={6} sx={{ maxWidth: '120px' }}>
          <Link underline="none" href={`/#/member/${MODE.VIEW}/${memberID}`}>
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              startIcon={<ArrowBackIcon />}
            >
              返回
            </Button>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ maxWidth: '120px' }}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="success"
            sx={{ color: 'white' }}
            startIcon={<PersonAddIcon />}
            onClick={() => addContact()}
          >
            新增聯絡人
          </Button>
        </Grid>
      </Grid>

      {!shouldPageUpdate ? (
        <Paper
          sx={{ width: '100%', overflow: 'hidden', padding: 1 }}
          elevation={5}
        >
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {contacts && columns
                    ? columns.map((column, index) => (
                        <TableCell
                          key={`${column.id}-${index}`}
                          align={column.align || 'center'}
                          sx={{
                            minWidth: column.minWidth || 'none',
                            padding: 1,
                            maxWidth: '100%',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))
                    : undefined}
                </TableRow>
              </TableHead>

              <TableBody>
                {contacts
                  ? contacts
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={`${row.memberID}-${index}`}
                            className={classes.root}
                          >
                            {contacts && columns
                              ? columns.map((column, index) => {
                                  return (
                                    <TableCell
                                      key={`${column.id}-${index}`}
                                      align={column.align || 'center'}
                                      sx={{
                                        padding: 1,
                                        minHeight: '0',
                                        maxWidth: '100%',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {column.id === 'function' ? (
                                        <Grid
                                          container
                                          columns={36}
                                          spacing={1}
                                        >
                                          <Grid item xs={12}>
                                            {!row.main ? (
                                              <Button
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                color="success"
                                                startIcon={<PersonIcon />}
                                                onClick={() =>
                                                  setAsMainContact(row.id)
                                                }
                                                sx={{
                                                  color: 'white',
                                                  maxWidth: '180px',
                                                }}
                                                size="small"
                                              >
                                                設爲主聯絡人
                                              </Button>
                                            ) : undefined}
                                          </Grid>
                                          <Grid item xs={8}>
                                            <Button
                                              type="button"
                                              fullWidth
                                              variant="contained"
                                              color="primary"
                                              startIcon={<EditIcon />}
                                              onClick={() =>
                                                editContact(row.id)
                                              }
                                              sx={{ maxWidth: '180px' }}
                                              size="small"
                                            >
                                              編輯
                                            </Button>
                                          </Grid>
                                          <Grid item xs={8}>
                                            <Button
                                              type="button"
                                              fullWidth
                                              variant="contained"
                                              color="info"
                                              startIcon={<RemoveRedEyeIcon />}
                                              onClick={() => viewMore(row.id)}
                                              sx={{
                                                maxWidth: '180px',
                                                color: 'white',
                                              }}
                                              size="small"
                                            >
                                              更多
                                            </Button>
                                          </Grid>
                                          <Grid item xs={8}>
                                            {!row.isOwner ? (
                                              <Button
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                color="error"
                                                startIcon={<DeleteIcon />}
                                                onClick={() => {
                                                  dialog.openConfirm({
                                                    message: `確定要刪除 "${row.name}" 此筆聯絡人資料嗎？`,
                                                    cancelColor: 'gray',
                                                    confirmColor: 'warning',
                                                    confirmText: '刪除',
                                                    onConfirm: () => {
                                                      setTimeout(() => {
                                                        deleteContact(row.id);
                                                      }, 100);
                                                    },
                                                  });
                                                }}
                                                sx={{ maxWidth: '180px' }}
                                                size="small"
                                              >
                                                刪除
                                              </Button>
                                            ) : undefined}
                                          </Grid>
                                        </Grid>
                                      ) : column.id === 'main' ? (
                                        <Checkbox
                                          inputProps={{
                                            'aria-label': 'main',
                                          }}
                                          disabled
                                          checked={row.main}
                                        />
                                      ) : (
                                        row[column.id]
                                      )}
                                    </TableCell>
                                  );
                                })
                              : undefined}
                          </TableRow>
                        );
                      })
                  : undefined}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            labelRowsPerPage="每頁顯示"
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={contacts ? contacts.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      ) : undefined}
    </>
  );
};

export default ContactsPage;
